import { tss } from "tss-react";
import GradientActions from "actions/GradientActions";

const useStyles = tss.create({
    root: {
        position: "relative",
        height: "100%",
        width: "100%",
        display: "inline-block",
    },
    flex: {
        display: "inline-flex",
        height: "100%",
        width: "100%",
        flexGrow: 1,
    },
    colorBlock: {
        height: 25,
        display: "inline-block",
    },
    labelBlock: {
        lineHeight: 1.43,
        fontSize: 10,
        display: "inline-block",
        textAlign: "left",
        borderLeft: "solid 1px silver",
        paddingLeft: 2,
        paddingTop: 5,
    },
});

function decimate(array: any, maxitem: number) {
    let skip: number = Math.trunc(array.length / maxitem);
    if (skip < 1) skip = 1;
    let result: any = [];
    for (let i: number = 0; i < array.length; i += skip) {
        let width: number = array[i].width;
        for (let j = 0; j < skip - 1; j++) {
            if (i + j < array.length) width += array[i + j].width;
        }
        array[i].width = width;
        result.push(array[i]);
    }
    return result;
}

type IProps = {
    source: any;
    histogram?: any;
    method?: number;
    showLabels?: boolean;
    isLimbo?: boolean;
    isAlpha?: boolean;
    style?: any;
};

export default function HorizontalColorPalette(props: IProps) {
    const { classes } = useStyles();
    var { source, histogram, method, showLabels, isLimbo, isAlpha, style } = props;
    var gradient: any = [];
    if (histogram && histogram.length > 0) {
        switch (method) {
            case 0:
            case 1:
                gradient = GradientActions.getLayerGradient(source, isAlpha);
                break;
            case 2:
                gradient = GradientActions.getQuantileGradient(histogram, source);
                break;
            case 3:
                gradient = GradientActions.getJenksGradient(histogram, source);
                break;
        }
    } else {
        gradient = GradientActions.getLayerGradient(source, isAlpha);
    }
    let totalWidth: number = 0.0;
    return (
        <div className={classes.root} style={style}>
            {!isLimbo ? (
                <div>
                    <div>
                        {gradient.map((item: any, index: number) => {
                            return (
                                <div
                                    key={"hc0-" + index}
                                    className={classes.colorBlock}
                                    style={{
                                        backgroundColor: item.color,
                                        display: "inline-block",
                                        width: 100.0 * item.width + "%",
                                    }}
                                ></div>
                            );
                        })}
                    </div>
                    {showLabels ? (
                        <div style={{ height: 20, overflow: "hidden" }}>
                            {decimate(gradient, 5).map((item: any, index: number) => {
                                if (totalWidth > 0.95) return "";
                                totalWidth += item.width;
                                return (
                                    <div
                                        key={"hc1-" + index + "-" + item.value}
                                        className={classes.labelBlock}
                                        style={{ width: 100.0 * item.width + "%" }}
                                    >
                                        {item.value.toFixed(2)}
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            ) : (
                <div>
                    <div
                        className={classes.colorBlock}
                        style={{
                            backgroundColor: "grey",
                            display: "inline-block",
                            width: "100%",
                        }}
                    ></div>
                    {showLabels ? (
                        <div style={{ height: 20, overflow: "hidden" }}>
                            <div className={classes.labelBlock} style={{ width: "100%" }}>
                                0
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            )}
        </div>
    );
}
